import { useEffect } from "react";
import styled from "styled-components";
import useGetCustomerDetail from "../../hooks/useGetCustomerDetail";
import theme from "../../theme";
import InputField from "./inputField";
import { Customer, SystemSetting } from "../../types/types";
import Spinner from "../spinner";
import { Button } from "../common/Button";
import { ModalLayout } from "../common/ModalLayout";
import { useWindowSize } from "@reactuses/core";
import { useI18n } from "../../locales";

const { md } = theme.screen;

const CustomerDetailModal: React.FC<{
  open: boolean;
  onPressNo: () => void;
  seq: number;
  setDetailData: any;
  onClickModify: any;
  detailData?: Customer;
  systemSetting: SystemSetting | null;
}> = (props) => {
  const {
    open,
    onPressNo,
    seq,
    setDetailData,
    onClickModify,
    systemSetting,
  } = props;
  const { width } = useWindowSize();
  const { t } = useI18n();

  const { data, isLoading } = useGetCustomerDetail(
    { seq },
    { fetch: open }
  );

  useEffect(() => {
    if (data) {
      setDetailData(data);
    }
  }, [data, setDetailData]);

  // console.log("상세정보페이지", data && data);
  // console.log("초기데이터", data);
  // console.log("초기디테일데이터", detailData);

  return (
    <ModalLayout
      open={open}
      onClose={onPressNo}
      width="520px"
      title={t.manageCustomer.detailInfoTitle}
    >
      {isLoading && <Spinner />}
      {data && <InputField data={data} />}
      <BtnWrapper>
        <Button
          onClick={onClickModify}
          bgColor={theme.statusColor.MAIN}
          hoverColor={theme.statusColor.MAIN_HOVER}
          isDisabled={!systemSetting?.update || isLoading}
        >
          {width <= md ? t.common.edit : t.manageCustomer.editInfoTitle}
        </Button>
        <Button
          bgColor={theme.color.neutral_400}
          onClick={onPressNo}
          hoverColor={theme.color.neutral_500}
        >
          {t.common.close}
        </Button>
      </BtnWrapper>
    </ModalLayout>
  );
};

const BtnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin: 0 50px;
  margin-top: 20px;

  button {
    width: 270px;
  }

  @media (max-width: ${md}px) {
    margin: 0px;
    margin-top: 20px;
  }
`;

export default CustomerDetailModal;
